import axios from "axios";
import { AppConstants } from "@/constants/AppConstants";

/**
 * API通信用クライアント（ファイルダウンロード）
 *
 * axios通信用のクライアントです。
 * サーバーサイドでトークンの検証をするため、HTTPヘッダにトークン情報を付与しています
 * また、レスポンスタイプにBlobを指定しています。
 * ※トークン認証が必要ない場合は、こちらではなくapiClientを使用してください
 *
 */
const apiClientDownload = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
  withCredentials: true,
  responseType: "blob",
});

apiClientDownload.interceptors.request.use((config) => {
  const token = localStorage.getItem(AppConstants.TOKEN_SESSION_NAME);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClientDownload;
